const playButton = document.querySelectorAll('.play-button.upload');

playButton.forEach(function (el) {
    el.addEventListener('click', function () {
        const parent = this.closest('.media');
        const videoHolder = parent.querySelector('.video-holder');
        const video = parent.querySelector('video');
        const picture = parent.querySelector('picture');

        videoHolder.classList.remove('hide');
        parent.classList.add('play');
        if (picture) picture.classList.add('hide');
        this.classList.add('hide');
        video.play();
    });
});

var playButtonsOnline = document.querySelectorAll('.play-button.online');

playButtonsOnline.forEach(function(button) {
    button.addEventListener('click', function() {
        let parentContainer = this.closest('.block_content_image_switch');
        let innerElement = parentContainer.querySelector('.media');
        let videoOnlineElement = parentContainer.querySelector('.video-container');

        if (videoOnlineElement) {
            innerElement.parentElement.classList.add('play');

            let parentElement = videoOnlineElement.parentElement;
            let videoProvider = videoOnlineElement.getAttribute('data-video-provider');
            let videoId = videoOnlineElement.getAttribute('data-video-id');

            switch (videoProvider) {
                case 'youtube':
                    videoOnlineElement.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId +
                        '?rel=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                    parentElement.classList.add('play');
                    break;
                case 'vimeo':
                    videoOnlineElement.innerHTML = '<iframe src="https://player.vimeo.com/video/' + videoId +
                        '?autoplay=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
                    let picture = parentElement.querySelector('picture');
                    parentElement.classList.add('play');
                    break;
            }
        }
    });
});